function getActiveInactiveDeleteStatus(status) {
  switch (status) {
    case 'ACTIVE':
      return 'Active';
    case 'INACTIVE':
      return 'In-Active';
    case 'DELETED':
      return 'Deleted';
    default:
      return 'Unknown';
  }
}

export default getActiveInactiveDeleteStatus;
